import 'whatwg-fetch';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { _throw } from 'rxjs/observable/throw';
import { empty } from 'rxjs/observable/empty';
import { of } from 'rxjs/observable/of';
import { switchMap, map } from 'rxjs/operators';
import { checkToken, getRefreshToken, setRefreshSetToken } from '../util/checkToken'
export class ClientSecurityApi {
  renewTokenIdentity(token) {
    let request = fetch(process.env.CLIENT_SECURITY_API + '/accesstokens', {
      method: 'PATCH',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.CLIENT_TOKEN,
        'Authorization': `Bearer ${token}`,
      }
    })

    return fromPromise(request).pipe(
      switchMap((response) => {
        if(response.status == 200) {
          return of(response.headers.get('X-Authorization'));
        } else if(response.status == 401) {
          console.warn("XPSession:", "Token Invalid or Expired.");
          return _throw(response.statusText);
        } else {
          console.error("XPSession:", "Unable to renew token, but will continue working until it expires.")
          return empty();
        }        
      })
    );
  }

  renewTokenJwt(token, customerCode) {
    let request = fetch(`${process.env.CLIENT_SECURITY_API_AUTH}/oauth/token`, {
        method: 'POST',
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.CLIENT_TOKEN_AUTH,
          'Authorization': `Bearer ${token}`,
          'accept': '*/*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          clientId: process.env.CLIENT_ID_TOKEN_AUTH,
          refreshToken: getRefreshToken('XPRefreshToken'),
          account: customerCode
        })
      })
      return fromPromise(request).pipe(
        switchMap((response) => {
          if(response.status == 200) {
            return fromPromise(response.json()).pipe(map((result) => {
              setRefreshSetToken('XPRefreshToken', result.refreshToken, 30)
              return result.accessToken
            }));
          } else if(response.status == 401) {
            console.warn("XPSession:", "Token Invalid or Expired.");
            return _throw(response.statusText);
          } else {
            console.error("XPSession:", "Unable to renew token, but will continue working until it expires.")
            return empty();
          }        
        })
      );
  }

  renewToken(token) {
    if(checkToken(token)) {
      const customerCode = checkToken(token)['https://xpi:com:br/account'];
      return this.renewTokenJwt(token, customerCode)
    } else {
      return this.renewTokenIdentity(token)
    }
  }
}